﻿(function (window, document) {
    var app = window.LBSApp = window.LBSApp || {};
    var isConsentInitialized = false;
    var preConsentDataLayer = [];

    // The consents need to be pushed to datalayer before we push event
    // We therefore cache the events in a separate array and then push these to the datalayer array wehn/if consent is given.
    window.addEventListener('CookieInformationConsentGiven', function (event) {
        isConsentInitialized = true;
        preConsentDataLayer.forEach(x => dataLayer.push(x));
    }, false);

    function pushToDatalayer(evt) {
        if (!isEventDisabled(evt.event)) {
            if (isConsentInitialized) {
                dataLayer.push(evt);
            }
            else {
                preConsentDataLayer.push(evt);
            }
            console.log(evt);
        }
    }

    function viewItemList(ecommerceObj) {
        if (!ecommerceObj) {
            return;
        }
        pushToDatalayer({ ecommerce: null });
        pushToDatalayer({
            event: "view_item_list",
            ecommerce: ecommerceObj
        });
    }

    function selectItem(ecommerceObj, item) {
        if (!ecommerceObj || !item) {
            return;
        }
        pushToDatalayer({ ecommerce: null });
        pushToDatalayer({
            event: "select_item",
            ecommerce: {
                item_list_id: ecommerceObj.item_list_id,
                item_list_name: ecommerceObj.item_list_name, 
                items: [item]
            }
        });
    }

    function beginCheckout(item) {
        if (!item) {
            return;
        }
        pushToDatalayer({ ecommerce: null });
        pushToDatalayer({
            event: "begin_checkout",
            ecommerce: {
                currency: "SEK",
                value: item.price,
                items: [item]
            }
        });
    }

    function addPaymentInfo(ecommerceObj, item, paymentType) {
        if (!ecommerceObj || !item || !paymentType) {
            return;
        }
        pushToDatalayer({ ecommerce: null });
        pushToDatalayer({
            event: "add_payment_info",
            ecommerce: {
                currency: "SEK",
                value: item.price,
                payment_type: paymentType,
                items: [item]
            }
        });
    }

    function purchase(paymentId, item, paymentType) {
        if (!paymentId || !item) {
            return;
        }

        // try to avoid to register a purchase event multiple times.
        if (!localStorage.getItem('gtm_purchase_payment_id_' + paymentId)) {
            pushToDatalayer({ ecommerce: null });
            pushToDatalayer({
                event: "purchase",
                ecommerce: {
                    transaction_id: paymentId,
                    value: item.price,
                    currency: "SEK",
                    items: [item],
                    payment_type: paymentType
                }
            });
            signUp(item.item_id)
            localStorage.setItem('gtm_purchase_payment_id_' + paymentId, 'true');
        }
        
    }

    function signUp(method) {
        if (!window.isUserAuthenticated) {
            pushToDatalayer({
                'event': 'sign_up',
                'method': method
            });
        }
    }

    function userLogin(userId, method) {
        if (!userId) {
            return
        }
        pushToDatalayer({
            'event': 'userLogin',
            'user_id': userId,
            'login_method': method
        });
    }

    function directDebitRegistered() {
        pushToDatalayer({
            'event': 'autogiro'
        });
    }

    function serverGeneratedEvent(evt) {
        if (!evt) {
            return;
        }
        pushToDatalayer(evt);
    }

    function selectPromotion(promotionData) {
        if (!promotionData
            || !promotionData.promotion_content
            || !promotionData.promotion_type
            || !promotionData.link_text
            || !promotionData.link_url) {
            return false;;
        }

        var ga4Data = {
            event_name: "select_promotion",
            promotion_content: promotionData.promotion_content,
            promotion_type: promotionData.promotion_type,
            link_text: promotionData.link_text,
            link_url: promotionData.link_url,
            allow_auto_collect: true
        };

        if (promotionData.promotion_name) {
            ga4Data.promotion_name = promotionData.promotion_name;
        }

        pushToDatalayer({ ga4_data: null });
        pushToDatalayer({
            event: "ga4_event",
            ga4_data: ga4Data,
            eventCallback: function () {
                location.href = promotionData.link_url
            },
            eventTimeout: 2000
        });
        return true;
    }

    function prizeShopClick(productName) {
        if (!productName) {
            return false;
        }

        pushToDatalayer({ ga4_data: null });
        pushToDatalayer({
            event: "ga4_event",
            ga4_data: {
                event_name: "prize_shop_click",
                product_name: productName,
                allow_auto_collect: true
            }
        });

        return true;
    }

    function trackPromotionClick(evt) {
        if (!evt || !evt.target || typeof evt.target.closest !== "function") {
            return;
        }

        var promotionLink = evt.target.closest("[data-lbs-gtm-promo-click-type]");

        if (!promotionLink) {
            return;
        }

        var linkText = (promotionLink.getAttribute("data-lbs-gtm-promo-click-link-text") || "").trim()
            || (promotionLink.innerText || promotionLink.textContent || "").trim();
        var promotionContent = (promotionLink.getAttribute("data-lbs-gtm-promo-click-promotion-content") || "").trim()
            || (promotionLink.innerText || promotionLink.textContent || "").trim();
        var promotionName = (promotionLink.getAttribute("data-lbs-gtm-promo-click-promotion-name") || "").trim();
        var promotionType = (promotionLink.getAttribute("data-lbs-gtm-promo-click-type") || "").trim();

        const success = selectPromotion({
            promotion_content: promotionContent,
            promotion_name: promotionName,
            promotion_type: promotionType,
            link_text: linkText,
            link_url: promotionLink.href || promotionLink.getAttribute("href")
        });
        if (success && window.LBSApp.GTM.IsEnabled) {
            evt.preventDefault();
        }
    }

    document.addEventListener("click", trackPromotionClick);

    function isEventDisabled(eventName) {
        if (!eventName || !window.LBSApp.GTM.DisabledDatalayerEvents) {
            return false;
        }
        return window.LBSApp.GTM.DisabledDatalayerEvents.indexOf(eventName) !== -1;
    }
    var gtm = window.LBSApp.GTM = window.LBSApp.GTM || {};
    gtm.Ecommerce = {
        viewItemList: viewItemList,
        selectItem: selectItem,
        beginCheckout: beginCheckout,
        addPaymentInfo: addPaymentInfo,
        purchase: purchase
    };
    gtm.signUp = signUp;
    gtm.userLogin = userLogin;
    gtm.directDebitRegistered = directDebitRegistered;
    gtm.serverGeneratedEvent = serverGeneratedEvent;
    gtm.selectPromotion = selectPromotion;
    gtm.prizeShopClick = prizeShopClick;
    gtm.IsEnabled = false;

})(window, document)
